/**
*
* Base
*
*/

( function( ) {
	'use strict';

	const html = document.documentElement;
	const scaleItemArray = document.querySelectorAll( '.scale__item' );
	const scaleItem = document.querySelector( '.scale__item' );
	const activeClass = 'scale__item--active';

	/**
	 *
	 * Scale Toggle
	 */
	function scaleToggle() {
		let scaleClass = this.getAttribute( 'data-scale-size' );
		html.setAttribute( 'data-scale', scaleClass );

		scaleItemArray.forEach( el => el.classList.remove( activeClass ) );

		this.classList.add( activeClass );

	}

	if( null != scaleItem ) {
		scaleItemArray.forEach( el => el.addEventListener( 'click', scaleToggle ) );
	}

} )();
